module.exports = __webpack_public_path__ + "img/trans-location.a486c634.svg";